import React from 'react';

export interface MenuItem {
  id: string;
  label: string;
  path: string;
  icon: React.ReactNode;
}

export const getMenuItems = (): MenuItem[] => [
  {
    id: 'home',
    label: 'Strona główna',
    path: '/dashboard',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: 'profile',
    label: 'Edytuj swoje dane',
    path: '/dashboard/edit-profile',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: 'create-lawsuit',
    label: 'Złóż pozew',
    path: '/dashboard/create-lawsuit',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: 'orders',
    label: 'Zamówienia',
    path: '/dashboard/orders',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: 'documents',
    label: 'Dokumenty',
    path: '/dashboard/documents',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM13 9V4L18 9H13ZM8 13H16V15H8V13ZM8 17H16V19H8V17Z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: 'messages',
    label: 'Wiadomości',
    path: '/dashboard/messages',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: 'change-password',
    label: 'Zmiana hasła',
    path: '/dashboard/change-password',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.34 17 9 15.66 9 14C9 12.34 10.34 11 12 11C13.66 11 15 12.34 15 14C15 15.66 13.66 17 12 17ZM15.3 8H8.7V6C8.7 4.16 10.16 2.7 12 2.7C13.84 2.7 15.3 4.16 15.3 6V8Z" fill="currentColor"/>
      </svg>
    ),
  },
];

